import { MdSave } from "react-icons/md";
import styled from "styled-components";
import React from "react";
// import CustomLoader from "components/CustomLoader";

const CustomFormSaveButton = (props) => {
  let rest = { ...props };
  delete rest.issubmitting;

  return (
    <Button {...rest}>
      <div className="btn-element-wrapper flex-box align-items-center">
        {props.issubmitting ? (
          <span
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdSave /> Saving...
          </span>
        ) : (
          <span
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdSave /> Save
          </span>
        )}
        {/* <span className="btn-label">{props.label}</span> */}
      </div>
    </Button>
  );
};

export default CustomFormSaveButton;

const Button = styled.button`
  cursor: pointer;
  min-width: 20px;
  min-height: 20px;
  width: max-content;

  .btn-element-wrapper {
    width: max-content;
    gap: 5px;
  }

  svg {
    font-size: 20px;
    height: 22px;
    width: auto;
  }

  .loaderContainer {
    background: transparent;
    div {
      display: none;
    }
  }
`;
